import localDB from "./localDB";
let GLOBAL = require('./globals');

const TicketData = {
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/tickets`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async listAll() {
        let response = await fetch(`${GLOBAL.BASE_URL}api/tickets-all`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/ticket/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/ticket/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async productDelete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/ticket/product/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async productUpdate(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/ticket/product/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async productAdd(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/ticket/product-list`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async sale(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/tickets-sale`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async check(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/ticket-check`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async checkDelete(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/ticket-check`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async updateClient(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/ticket-client/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
};

export default TicketData;



// WEBPACK FOOTER //
// ./src/data/TicketData.js